import { Controller } from "@hotwired/stimulus"

// Mobile off-canvas navigation. Replaces the inline <script> that re-bound its
// handlers on every turbo:load, and adds the keyboard and focus behaviour an
// off-canvas dialog needs.
export default class extends Controller {
  static targets = ["panel", "backdrop", "dialog"]

  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape)
    document.body.classList.remove("overflow-hidden")
  }

  open() {
    this.dialogTarget.hidden = false
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.closeOnEscape)

    requestAnimationFrame(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.panelTarget.classList.remove("-translate-x-full")
      this.panelTarget.querySelector("a, button")?.focus()
    })
  }

  close() {
    this.backdropTarget.classList.add("opacity-0")
    this.panelTarget.classList.add("-translate-x-full")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.closeOnEscape)

    setTimeout(() => { this.dialogTarget.hidden = true }, 300)
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }
}
